import * as React from 'react';

interface UnitsToggleProps {
    isMmol: boolean;
    onToggleClick: () => void;
}

export class UnitsToggle extends React.Component<UnitsToggleProps> {
    constructor(props: UnitsToggleProps) {
        super(props);
    }

    render() {
        return (
            <button id="GlucoseUnits" className="btn btn-primary" onClick={(e: any) => { e.target.blur(); this.props.onToggleClick() }}><i className="fa fa-toggle-on fa-fw" aria-hidden="true"></i>{this.props.isMmol ? "mmol/L" : "mg/dl"}</button>
        );
    }
}